import React from 'react';
import { TFunction } from 'react-i18next';
import {
  Text,
  Link,
  CodeSnippet,
  Stack,
  Trans,
  CodeInline,
  OrderedList,
} from '@piwikpro/ui-components';
import { App } from '../../../model';

const PRODUCT_ANALYTICS_INSTAL_METHOD_ACTION_TYPES = {
  ANGULAR: '@platform/command/appInstallation/angular',
};

const getAngularSnippetCode = (containerUrl, containerId) => `import { NgxPiwikProModule } from '@piwikpro/ngx-piwik-pro';

@NgModule({  
  declarations: [  
    AppComponent  
  ],  
  imports: [  
    BrowserModule,  
    NgxPiwikProModule.forRoot('${containerId}', '${containerUrl}')
  ],  
  providers: [],  
  bootstrap: [AppComponent]  
})  
export class AppModule { }`;

interface AngularInstallProps {
  app: App
  containerUrl: string
  containerUrlFailed: boolean
  t: TFunction
  handleCopyToClipboard: (result: boolean, productAnalyticsActionType: string) => void
}

const AngularInstall: React.FC<AngularInstallProps> = ({
  app,
  containerUrl,
  containerUrlFailed,
  t,
  handleCopyToClipboard,
}) => (
  <>
    <OrderedList>
      <Stack vertical>
        <Stack.Item>
          <Stack vertical spacing="narrow">
            <Stack.Item>
              <OrderedList.Item>
                {t('apps.details.installation.angular.instruction.line1.part1')}
              </OrderedList.Item>
            </Stack.Item>
            <Stack.Item>
              <Trans
                i18nKey="apps.details.installation.angular.instruction.line1.part2"
                components={[
                  <CodeInline dataId="TextStyle">Code</CodeInline>,
                ]}
              />
            </Stack.Item>
            <Stack.Item>
              <OrderedList.Item>
                <Trans
                  i18nKey="apps.details.installation.angular.instruction.line2.part1"
                  components={[
                    <CodeInline dataId="TextStyle">Code</CodeInline>,
                  ]}
                />
              </OrderedList.Item>
            </Stack.Item>
            <Stack.Item fill>
              <CodeSnippet
                error={containerUrlFailed}
                code={getAngularSnippetCode(containerUrl, app.id)}
                onCopy={result => handleCopyToClipboard(
                  result,
                  PRODUCT_ANALYTICS_INSTAL_METHOD_ACTION_TYPES.ANGULAR,
                )}
                mode="no-highlight"
              />
            </Stack.Item>
            <Stack.Item>
              <OrderedList.Item>
                {t('apps.details.installation.angular.instruction.line3')}
              </OrderedList.Item>
            </Stack.Item>
            <Stack.Item>
              <OrderedList.Item>
                <Trans
                  i18nKey="apps.details.installation.angular.instruction.line4"
                  components={[
                    <Link href={`/analytics/#/${app.id}/settings/debugger/`}>tracker debugger</Link>,
                  ]}
                />
              </OrderedList.Item>
            </Stack.Item>
          </Stack>
        </Stack.Item>
      </Stack>
    </OrderedList>
    <Stack vertical>
      <Stack.Item previousSpacing="wide" />
      <Stack.Item>
        <Text as="p">
          {t('apps.details.installation.instruction.help.part1')}
          <Link href="https://developers.piwik.pro/en/latest/data_collection/web/frameworks/Piwik_PRO_Library_for_Angular.html">
            {t('apps.details.installation.links.installGuide')}
          </Link>
          {t('apps.details.installation.instruction.help.part2')}
          <Link href="http://community.piwik.pro/">
            {t('apps.details.installation.links.community')}
          </Link>
          .
        </Text>
      </Stack.Item>
    </Stack>
  </>
);

export default AngularInstall;
